import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deletePost } from "../services/postServices";
import { FEED_QUERY_KEYS } from "../queryKeys";

interface UsePostDeleteMutationProps {
  postId: number;
}

export const usePostDeleteMutation = ({ postId }: UsePostDeleteMutationProps) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: () => deletePost(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [...FEED_QUERY_KEYS.all, "posts", "list"] });
    },
  });

  return {
    deletePost: mutation.mutate,
    isDeleting: mutation.isPending,
  };
};
